import queryString from 'query-string';
import { useMemo } from 'react';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';

function buildUrlWithParam(pathname: string, query?: Record<string, any>) {
  const queryStr = query && Object.keys(query).length > 0 ? '?' + queryString.stringify(query) : '';
  return `${pathname}${queryStr}`;
}

export function useRouter(): any {
  const params = useParams();
  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch();

  // Return our custom router object
  // Memoize so that a new object is only returned if something changes
  return useMemo(
    () => ({
      // For convenience add push(), replace(), pathname at top level
      push: history.push,
      pushWithParam: (pathname: string, query?: Record<string, any>) => history.push(buildUrlWithParam(pathname, query)),
      replace: history.replace,
      pathname: location.pathname,
      // Merge params and parsed query string into single "query" object
      // so that they can be used interchangeably.
      // Example: /:topic?sort=popular -> { topic: "react", sort: "popular" }
      query: {
        ...queryString.parse(location.search), // Convert string to object
        ...params,
      },
      // Include match, location, history objects so we have
      // access to extra React Router functionality if needed.
      match,
      location,
      history,
    }),
    [params, match, location, history]
  );
}

export default useRouter;
